// don't import from this file, please import from 'navigation/hooks/use-route'
export { useRoute } from 'navigation/hooks/use-route';
